<template>
	<div class="mini-shop-page">
		<div class="page-head">
			<div class="tab-bar">
				<button
					v-for="item in tabs"
					:key="item.name"
					type="button"
					class="tab-btn"
					:class="{ 'is-active': tab === item.name }"
					@click="switchTab(item.name)"
				>{{ item.label }}</button>
			</div>
			<el-form :inline="true" size="small" class="filter-form" @submit.native.prevent="onRefresh">
				<el-form-item>
					<el-button type="primary" :loading="loading" @click="onRefresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div class="table-wrap">
			<el-table
				:key="tab"
				:data="list"
				size="small"
				height="100%"
				v-loading="loading"
				class="shop-table"
			>
				<el-table-column label="消费者" min-width="180">
					<template slot-scope="scope">
						<div class="buyer-cell">
							<div class="avatar">
								<img v-if="scope.row.buyer_avatar" :src="scope.row.buyer_avatar" alt="" width="32" height="32">
								<i v-else class="el-icon-user"></i>
							</div>
							<div class="buyer-meta">
								<div class="buyer-name">{{ scope.row.buyer_name || '-' }}</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="商品" min-width="220">
					<template slot-scope="scope">
						<div class="goods-preview">
							<div
								v-for="(item, idx) in previewItems(scope.row)"
								:key="idx"
								class="thumb"
							>
								<img v-if="item.product_pic" :src="item.product_pic" alt="" width="48" height="48">
								<i v-else class="el-icon-picture-outline"></i>
							</div>
							<div class="goods-meta">
								<div>{{ firstItemText(scope.row) }}</div>
								<div class="sub">{{ itemCount(scope.row) }} 件</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="平台订单号" min-width="160" show-overflow-tooltip>
					<template slot-scope="scope">{{ scope.row.trade_no || '-' }}</template>
				</el-table-column>
				<el-table-column label="售后状态" width="110" align="center">
					<template slot-scope="scope">{{ scope.row.status_text || '-' }}</template>
				</el-table-column>
				<el-table-column label="退款金额" width="110" align="center">
					<template slot-scope="scope">{{ scope.row.refund_fee_for_buyer_yuan || '-' }}</template>
				</el-table-column>
				<el-table-column label="申请时间" width="160" align="center">
					<template slot-scope="scope">{{ scope.row.create_time_str || '-' }}</template>
				</el-table-column>
				<el-table-column label="操作" width="80" align="center" fixed="right">
					<template slot-scope="scope">
						<span class="cell-link" @click="openDetail(scope.row)">详情</span>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<div class="pager">
			<el-pagination
				background
				layout="total, sizes, prev, pager, next"
				:total="total"
				:current-page="page"
				:page-size="limit"
				:page-sizes="pageSizes"
				@current-change="onPageChange"
				@size-change="onSizeChange"
			/>
		</div>

		<after-sale-dialog :visible.sync="detailVisible" :service-id="serviceId" />
	</div>
</template>

<script>
	import AfterSaleDialog from './afterSaleDialog.vue'
	import {
		MINI_CONFIG_API,
		MINI_SHOP_AFTER_SALE_TABS,
		MINI_SHOP_PAGE_SIZES,
		getApiErrorMessage,
	} from '@/constants/retailPlatform'

	export default {
		name: 'MiniprogramService',
		components: { AfterSaleDialog },
		data() {
			return {
				tabs: MINI_SHOP_AFTER_SALE_TABS,
				pageSizes: MINI_SHOP_PAGE_SIZES,
				tab: 'all',
				page: 1,
				limit: 20,
				total: 0,
				list: [],
				loading: false,
				detailVisible: false,
				serviceId: 0,
			}
		},
		mounted() {
			this.loadList()
		},
		methods: {
			previewItems(row) {
				const items = (row && row.items) || []
				return items.slice(0, 3)
			},
			itemCount(row) {
				return ((row && row.items) || []).length
			},
			firstItemText(row) {
				const items = (row && row.items) || []
				if (!items.length) {
					return '-'
				}
				const first = items[0]
				return ((first.product_brand || '') + ' ' + (first.product_style_number || '')).trim() || '-'
			},
			switchTab(name) {
				if (this.tab === name) {
					return
				}
				this.tab = name
				this.page = 1
				this.loadList()
			},
			onRefresh() {
				this.page = 1
				this.loadList()
			},
			onPageChange(page) {
				this.page = page
				this.loadList()
			},
			onSizeChange(limit) {
				this.limit = limit
				this.page = 1
				this.loadList()
			},
			loadList() {
				const params = {
					page: this.page,
					limit: this.limit,
				}
				if (this.tab !== 'all') {
					params.status = Number(this.tab)
				}
				this.loading = true
				this.$axios.get(MINI_CONFIG_API.shopAfterSaleList, {
					params: params,
				}).then((res) => {
					if (!res.data || res.data.code != 0) {
						this.list = []
						this.total = 0
						this.$message.error(getApiErrorMessage(res, '获取售后失败'))
						return
					}
					const data = res.data.data || {}
					this.list = data.list || []
					this.total = Number(data.total) || 0
				}).catch((err) => {
					console.log(err)
					this.list = []
					this.total = 0
					this.$message.error('获取售后失败')
				}).finally(() => {
					this.loading = false
				})
			},
			openDetail(row) {
				if (!row || !row.id) {
					return
				}
				this.serviceId = row.id
				this.detailVisible = true
			},
		},
	}
</script>

<style scoped lang="less">
	.mini-shop-page {
		height: 100%;
		display: flex;
		flex-direction: column;
		background: #fff;
		padding: 12px 16px 8px;
		box-sizing: border-box;
		overflow: hidden;
	}

	.page-head {
		flex: none;
	}

	.tab-bar {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ebeef5;
		margin-bottom: 12px;
	}

	.tab-btn {
		position: relative;
		display: inline-flex;
		align-items: center;
		height: 40px;
		padding: 0 16px;
		border: 0;
		background: transparent;
		color: #606266;
		font-size: 14px;
		line-height: 1;
		cursor: pointer;
		outline: none;

		&.is-active {
			color: #ff4714;
			font-weight: 500;

			&::after {
				content: '';
				position: absolute;
				left: 16px;
				right: 16px;
				bottom: 0;
				height: 2px;
				background: #ff4714;
			}
		}
	}

	.filter-form {
		display: flex;
		align-items: center;
		margin-bottom: 12px;

		/deep/ .el-form-item {
			margin: 0 8px 0 0;
		}
	}

	.table-wrap {
		flex: 1;
		min-height: 0;
	}

	.shop-table {
		width: 100%;
	}

	.buyer-cell,
	.goods-preview {
		display: flex;
		align-items: center;
		min-width: 0;
	}

	.avatar,
	.thumb {
		width: 32px;
		height: 32px;
		flex: none;
		margin-right: 8px;
		border-radius: 50%;
		background: #f5f6f8;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 32px;
			height: 32px;
			object-fit: cover;
			display: block;
		}

		i {
			color: #c0c4cc;
		}
	}

	.thumb {
		width: 48px;
		height: 48px;
		border-radius: 4px;
		margin-right: 6px;

		img {
			width: 48px;
			height: 48px;
		}
	}

	/deep/ .thumb img,
	/deep/ .avatar img {
		width: 100% !important;
		height: 100% !important;
		max-width: 48px;
		max-height: 48px;
		object-fit: cover;
		display: block;
	}

	.buyer-meta,
	.goods-meta {
		min-width: 0;
	}

	.buyer-name {
		color: #303133;
		line-height: 1.4;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.sub {
		margin-top: 2px;
		font-size: 12px;
		color: #909399;
	}

	.cell-link {
		color: #ff4714;
		cursor: pointer;
		font-size: 13px;
	}

	.pager {
		flex: none;
		padding: 10px 0 4px;
		text-align: right;
	}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/miniprogram/service.vue